import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {
  showDPO = false;

  onShowDPO() {
    this.showDPO = true;
  }

  onCloseDPO() {
    this.showDPO = false;
  }
}
